/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Sync_Now_ButtonInputs */



/**
* | output |
* | --- |
* | "Sync now" |
*
* @param {Team_Share_Sync_Now_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_sync_now_button = /** @type {((inputs?: Team_Share_Sync_Now_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Sync_Now_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sync now")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sync now")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sync now")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Sync now")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sync now")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Sync now")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Sync now")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Sync now")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sync now")
	return /** @type {LocalizedString} */ ("Sync now")
});